import OtherIngredients from "@gaiaProfessionals/Icons/Ingredient";
import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Slash from "@insite/mobius/Icons/Slash";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    const product = state.customMeetYourHerbsReducer?.product;
    return {
        ingredientsOther: product?.sellable_item[0].ingredients_other,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface GAIAMYHOtherIngredientsStyles {
    containerWrapper?: InjectableCss;
    cardWrapper?: InjectableCss;
    categoryImageItem?: InjectableCss;
    image?: IconPresentationProps;
    titleWrapper?: TypographyProps;
    contentWrapper?: TypographyProps;
}
const styles: GAIAMYHOtherIngredientsStyles = {
    containerWrapper: {
        css: css`
            background: #f3efeb;
        `,
    },
    cardWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            padding: 30px 27px 47px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    categoryImageItem: {
        css: css`
            &:first-child {
                border-right: 1px solid #d1d1d1;
                opacity: 1;
                padding-right: 69.5px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 30px;
                            padding-bottom: 30px;
                        `,
                        css`
                            margin-bottom: 30px;
                            padding-bottom: 30px;
                        `,
                        null,
                        null,
                        null,
                    ])};
            }
            &:last-child {
                padding-left: 111.5px;
                border-right: none;
            }
            padding: 0px;
            display: block;

            text-align: center;
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        &:first-child {
                            border-right: none;
                            border-bottom: 1px solid #d1d1d1;
                            opacity: 1;
                            padding-right: 0;
                        }
                        &:last-child {
                            padding-left: 0;
                            border-bottom: none;
                        }
                    `,
                    css`
                        width: 100%;
                        &:first-child {
                            border-right: none;
                            border-bottom: 1px solid #d1d1d1;
                            opacity: 1;
                            width: 100%;
                            padding: 40px 0;
                            padding-right: 0;
                        }
                        &:last-child {
                            padding-left: 0;
                            border-bottom: none;
                        }
                    `,
                    css`
                        width: 48%;
                        &:first-child {
                            padding-right: 0;
                        }
                        &:last-child {
                            padding-left: 0;
                        }
                    `,
                    css`
                        width: 48%;
                        &:first-child {
                            padding-right: 0;
                        }
                        &:last-child {
                            padding-left: 0;
                        }
                    `,
                    null,
                ])};
        `,
    },
    image: {
        css: css`
            width: 64px;
            height: 64px;
            svg {
                width: 64px;
                height: 64px;
                color: ${getColor("primary")};
            }
        `,
    },
    titleWrapper: {
        css: css`
            font-size: 20px;
            color: #333333;
            margin: 23px 0 15px;
            display: block;
            text-align: center;
            font-family: "LibreBaskerville";
        `,
    },
    contentWrapper: {
        css: css`
            width: 100%;
        `,
    },
};

export const GAIAMYHOtherIngredients: React.FC<Props> = ({ ingredientsOther }) => {
    if (!ingredientsOther) {
        return null;
    }
    return (
        <StyledWrapper {...styles.containerWrapper}>
            <StyledWrapper {...styles.cardWrapper}>
                <StyledWrapper {...styles.categoryImageItem}>
                    <Icon src={OtherIngredients} {...styles.image} />
                    <Typography {...styles.titleWrapper}>Other Ingredients</Typography>
                    <Typography as="p">
                        <Typography {...styles.contentWrapper}>{ingredientsOther}</Typography>
                    </Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.categoryImageItem}>
                    <Icon src={Slash} {...styles.image} />
                    <Typography {...styles.titleWrapper}>Does Not Contain</Typography>
                    <Typography as="p">
                        <Typography {...styles.contentWrapper}>NA</Typography>
                    </Typography>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GAIAMYHOtherIngredients),
    definition: {
        group: "MYH Product Details" as WidgetGroup,
        displayName: "GAIA MYH Other Ingredients",
    },
};

export default widgetModule;
